
<template>
  <AquassistPage>
    <template v-slot:content>
      <JoinTeam />
    </template>
  </AquassistPage>
</template>

<script>
import AquassistPage from '@/components/login/AquassistPage.vue';
import JoinTeam from '@/components/team/JoinTeam.vue';

export default {
    components: {
        AquassistPage,
        JoinTeam,
    },
};
</script>
